import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = r((e, l) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: l,
    ...e,
    image: (a) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M1 13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2h-2v2H3v-2H1zm9.829-6.828L9 4.342V11H7V4.344L5.172 6.172 3.758 4.757l3.535-3.535a1 1 0 0 1 1.415 0l3.535 3.535z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "UploadIcon";
export {
  s as UploadIcon,
  s as default
};
//# sourceMappingURL=index.js.map
